module.exports = __webpack_public_path__ + "static/heroslider3-424d353c12c3ebe90ee9d6effc5d851d.jpg";